import { type ListDropdownItem } from '@sr/types';

export const otherLoadCarriersName = (t: (key: string) => string) => {
  const otherLoadCarriers: ListDropdownItem[] = [
    {
      label: t('rented-containers.use-container-groups.container.groups.bin'),
      type: 'value',
      value: 'bin',
      children: [],
    },
    {
      label: t('rented-containers.use-container-groups.container.groups.box'),
      type: 'value',
      value: 'box',
      children: [],
    },
    {
      label: t('rented-containers.use-container-groups.container.groups.cage'),
      type: 'value',
      value: 'cage',
      children: [],
    },
    {
      label: t('rented-containers.use-container-groups.container.groups.compactor'),
      type: 'value',
      value: 'compactor',
      children: [],
    },
    {
      label: t('rented-containers.use-container-groups.container.groups.container'),
      type: 'value',
      value: 'container',
      children: [],
    },
    {
      label: t('rented-containers.use-container-groups.container.groups.pallet'),
      type: 'value',
      value: 'pallet',
      children: [],
    },
    {
      label: t('rented-containers.use-container-groups.container.groups.sales-packaging'),
      type: 'value',
      value: 'sales-packaging',
      children: [],
    },
    {
      label: t('rented-containers.use-container-groups.container.groups.waste-bin'),
      type: 'value',
      value: 'waste-bin',
      children: [],
    },
  ];

  return otherLoadCarriers;
};
